import React, { Component } from 'react'
import Responsive from '../../components/Responsive'
import { QRCode } from 'react-qrcode-logo'
import { conditionalWidth } from '../../utils/useful'

export default class BookingSuccess extends Component {
    state = {
        receipt: [
            { title: 'Service name', des: 'Office Renting' },
            { title: 'Date of reservation', des: '18 Aug 2023, 09:30 PM' },
            { title: 'Booking number', des: '235NS34434VBY43N' },
            { title: 'Provider', des: 'Sara Mohseni' },
            { title: 'Recipient', des: 'Pedram Peazhman' },
            { title: 'Recipient Number', des: '+98 902 1377 118' },
            { title: 'Reserved date', des: '18 May 2023' },
            { title: 'Deposit', des: '$100' },
            { title: 'Settlement amount', des: '$300' },
        ]
    }
    render() {

        return (
            <div className='w-100 h-100'>
                <div className='d-flex flex-wrap h-100 m-3 br-20' style={{ backgroundColor: '#F3EFF6', overflow: 'hidden' }}>
                    <Responsive styles={{ backgroundColor: '#956DB5' }} width={this.props.width} media={{ xs: '12', 400: '12', 700: 'none', lg: '1', xl: '1' }}>
                        <div className='flexcc h-100'>
                            <p className={' text-center white font-size-18 weight-500 ' + conditionalWidth(this.props.width, { xs: 'p-3', 400: 'p-3', 700: 'p-3', lg: 'rotate-270', xl: 'rotate-270' })} style={{ whiteSpace: 'nowrap' }}>Company name</p>
                        </div>
                    </Responsive>
                    <Responsive width={this.props.width} height={'100%'} media={{ xs: '12', 400: '12', 700: '8', lg: '7', xl: '9' }}>
                        <div className={'flexcc h-100 ' + conditionalWidth(this.props.width, { xs: 'd-none', 400: 'd-none', 700: 'd-block', lg: 'd-none', xl: 'd-none' })} style={{ backgroundColor: '#956DB5' }}>
                            <p className=' text-center white font-size-18 weight-500 p-3' style={{ whiteSpace: 'nowrap' }}>Company name</p>
                        </div>
                        <div className='w-100 d-flex flex-wrap p-1'>
                            {this.state.receipt.map((prop, index) => {
                                return (
                                    <Responsive width={this.props.width} media={{ xs: '12', 400: '6', 700: '4', lg: '4', xl: '4' }}>
                                        <div className='p-3'>
                                            <p className='font-size-12 main-c7 weight-300'>{prop.title}</p>
                                            <p className='font-size-14 main-c3'>{prop.des}</p>
                                        </div>
                                    </Responsive>
                                )
                            })}
                        </div>
                    </Responsive>
                    <Responsive width={this.props.width} media={{ xs: '12', 400: '12', 700: '4', lg: '4', xl: '2' }}>
                        <div className='flexcc flex-column h-100 w-100 p-4' style={{ borderLeft: conditionalWidth(this.props.width, { xs: "none", 400: 'none', 700: '2px dashed #777', lg: '2px dashed #777', xl: '2px dashed #777' }), borderTop: conditionalWidth(this.props.width, { xs: '2px dashed #777', 400: '2px dashed #777', 700: 'none' }) }}>
                            <p className='main-c6 font-size-12 mb-2'>Scan to Check in</p>
                            <QRCode onClick={() => this.props.visitApplet()} quietZone={0} ecLevel={'H'} size="120" logoPadding={0} logoImage={'/assets/icons/booking/qrcode.png'} removeQrCodeBehindLogo={true} logoWidth={30} qrStyle={'dots'} eyeRadius={[[10, 10, 0, 10], [10, 10, 10, 0], [10, 0, 10, 10],]} eyeColor={'#333'} bgColor={'#F3EFF6'} enableCORS={true} />
                            <p className='main-c5 font-size-16 mt-2'>ID #########</p>
                        </div>
                    </Responsive>
                </div>
            </div>
        )
    }
}
